import React, { useState, useEffect } from "react";

import { SAdefaultValues, selectDateOrTime } from "../../../../../../services/saleAnalysis-services";
import {
    Button,
    Chip,
    colors,
    Container,
    Dialog,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import useFetchURL from "../../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../../help/Api";
import TotalCard from "../../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../../../Context/InshData";

import ReplyIcon from "@material-ui/icons/Reply";
import deepRenameKeys from "deep-rename-keys";
import MultiSandsSearchTable from "./MultiSandsSearchTable";
import MultiSandsSearchForm from "./MultiSandsSearchForm";
import { GetItemFromOptions } from "../../../../../../services/global-services";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function MultiSandsSearch(props) {
    const {   openSearchMdl,  handCloseDw,
        onRowClick,AutoOptions,transition,isReceipt,AutoOptionsB
    } = props;
    const { t } = useTranslation(["forms", "translation"]);
   
     const typePays = [
        { id: -1, name: t("forms:all"), label: t("forms:all") },
        { id: 1, name: t("forms:cash"), label: t("forms:cash") },
        { id: 2, name: t("forms:network"), label: t("forms:network") },
        { id: 3, name: t("forms:bank2"), label: t("forms:bank2") },

      ];
      let nameUser=AutoOptions.Users[0].name;
      let idUser=AutoOptions.Users[0].id;
      const [branches, setBranches] = useState(() => {
        return [{ id: -1, name: t("forms:all") }, ...AutoOptionsB?.Branches];
    });
    const valuebranch = GetItemFromOptions(sto.branchi,AutoOptionsB.Branches??[]);

    const initialSearchObject = {
        dateFrom: moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD"),
        timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        user: { id: sto.User_typei == 1 ? -1 : idUser, name: sto.User_typei == 1 ? t("forms:all") : nameUser },
        branch:   sto.User_typei == 1?branches[0]:valuebranch,
        selectTime: selectDateOrTime[0],
        sales_man: { id: -1, name: t("forms:all") },
        cust: { id: -1, name: t("forms:all"),code:-1 },
        acc_code: { id: -1, name: t("forms:all"),code:-1 },
        date_time: "false",
        refno: "",
        id: "",
        notes:"",
        tname:isReceipt?"1":"0",
        isAdmin: sto.User_typei == 1,
        value:'',
        valFrom:'',
        valto:'',
        pay_type: typePays[0],
        center: { id: -1, name: t("forms:all") },
    };

 
    const [rptParams, setRptParams] = React.useState(initialSearchObject);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const viewHandle = async () => {

        setData([]);
        setFetching(true);
        await axios
            .get(
              uri+
                `AccountReports/MultiSandsSearch?branch=${rptParams?.branch?.id}
        &&id=${rptParams?.id}
        &&tname=${rptParams?.tname}
        &&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}
        &&sale_emp=${rptParams?.user.id}
        &&notes=${rptParams?.notes}
        &&center=${rptParams.center?.id}
        &&type=${rptParams.pay_type?.id} 
        &&value=${rptParams?.value}
        &&valfrom=${rptParams?.valFrom}
        &&valto=${rptParams?.valto}`
            )
            .then((res) => {
                setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                // toast.err(t("fetch-error"));
                setData([]);
            });
    };
    const his = useHistory();


    let excel_name = "SandsReports";
    var columns = [
        { title: t("no"), field: "id", },
        { title: t("date"), field: "date",},
        {
          title: t("amount"),
          field: "val",
         
        },
        {
          title: t("delegate"),
          field: "empName",
        
        },
        {
          title: t("ref-no"),
          field: "check_no",
        
        },
        {
          title: t("account"),
          field: "acc_name",
       
        },
        {
          title: t("note"),
          field: "notes",
        
        },
       
      ];
      const excelHeaders = deepRenameKeys(columns, (key) => {
        if (key === "field") return "key";
        if(key === "title") return "label";  
      });
    
    useEffect(() => {
        console.log("the data is", rptParams);
    });
    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });

        // prop=='dateFrom' ? rptParams.dateFrom=e.target.value : rptParams.dateTo=e.target.value
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });      
    };
    const onChangeAutoDataCust = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue,acc_code: newValue});
        
    };
    
    return (
        <Dialog
        fullScreen
        open={openSearchMdl}
        onClose={handCloseDw}
        TransitionComponent={transition}
        key={transition ? transition.name : ""}
        >
            <div className={classes.root}>
                <Grid container item xs={12}>
                    <Typography
                        size="small"
                        className={classes.headerTitle}
                        color="primary"
                    >
                        {t("forms:vouchers-search")}
                    </Typography>
                </Grid>
                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: "#808080",
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <MultiSandsSearchForm
                            {...{
                                rptParams,
                                onChangeData,
                                onChangeAutoData,
                                typePays,
                              AutoOptions,
                              branches,
                              AutoOptionsB,
                            }}
                        />
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <Hidden smUp={["sm"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            ( inshst.sal.iconBtnAcc,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.buttonAcc]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:show")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtnAcc,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.buttonAcc]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:view")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden smUp={["sm"]}>

                                <Grid item >
                                    {data.sanadData && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data.sanadData}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ borderRadius: 0 }}
                                                className={[clasui.buttonAcc]}
                                            >
                                                {t("forms:excel")}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item >
                                    {data.sanadData && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data.sanadData}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ borderRadius: 0 }}
                                                className={[clasui.buttonAcc]}
                                            >
                                                {t("forms:excel_export")}{" "}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>
                           
                            <Grid item>
                                <Button
                                    variant="contained"
                                    // startIcon={<KeyboardReturnSharpIcon />}
                                    startIcon={<ReplyIcon />}
                                    color="secondary"
                                    size="large"
                                    aria-label="open drawer"
                                    className={[clasui.button, clasSp.clcan]}
                                    style={
                                        ( inshst.sal.iconBtn,
                                            { borderRadius: 0 })
                                    }
                                   onClick={() => handCloseDw()}
                                >
                                    {/* {t("forms:exit")} */}
                                    {t("forms:back")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                    <Container maxWidth={true} style={{ padding: "4px" }}>
                        <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                            
                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className:  classes.purchTotalCard ,
                                        title: t("forms:count_row"),
                                        value: data?.multiSanadData?.length,
                                    }}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className: classes.purchTotalCard,
                                        title: t("forms:totals"),
                                        value: (data?.multiSanadData?.reduce((a, v) => (a = a + v.val), 0).toFixed(2)),
                                    }}
                                />
                            </Grid>

                          
                        </Grid>
                    </Container>
                    <br />
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                    >
                        <Grid container justifyContent="center">
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetching} color="#808080"/>
                                {!fetching && (
                                    <MultiSandsSearchTable
                                        {...{
                                            //  data: data ? data : [],
                                            data: data?.multiSanadData ? data.multiSanadData : [],
                                            onRowClick,isReceipt
                                        }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </Typography>
            </div>
        </Dialog>
    );
}
